import { authFailure, sharedAuthMessage } from '../../api';

/** What sending a sign-in link logs and announces (useResend). */
export const SIGN_IN_LINK_RESEND_MESSAGES = {
  failedLog: 'Sending a sign-in link failed',
  sent: 'Email sent. Check your inbox, and your spam folder.',
  failed: "We couldn't send the link. Try again in a few minutes.",
} as const;

/** What /sign-in/link tells the player. */
export const SIGN_IN_LINK_MESSAGES = {
  /** On the address form, when the link was sent to another address. */
  wrongEmail: 'This link was sent to a different address. Enter the address you asked for it with.',
  checkFailed: "We couldn't check your link. Try again in a moment.",
  signInFailed: "We couldn't sign you in. Try again in a moment.",
} as const;

/** The alert for a failed call: too many requests and network failures have their own message, all else `fallback`. */
export const signInLinkErrorMessage = (error: unknown, fallback: string): string =>
  sharedAuthMessage(authFailure(error)) ?? fallback;
